import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../@shared/shared.module';

import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
import { ExerciseTaskModuleComponent } from './exercise-task-module.component';
import { ExerciseTaskService } from './exercise-task-module.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MaterialModule,
    SharedModule,
  ],
  declarations: [ExerciseTaskModuleComponent],
  exports: [ExerciseTaskModuleComponent],
  providers: [ExerciseTaskService],
})
export class ExerciseTaskModuleModule {}
